import { Utils } from '@gv/triage-components';

import { URL } from 'api/constants';
import { generateUrl } from 'utils/helpers';

import { apiInstance } from '../instance';

import { downloadXLSXRequest } from './types';

const { addParamsToUrl } = Utils.Query;

export const downloadXLSX = ({
  url,
  end,
  start,
  orderBy,
  is_test,
  direction,
  hospitalId,
  departmentId,
}: downloadXLSXRequest) => {
  const requestUrl = hospitalId ? generateUrl(url, { hospitalId }) : url;

  return apiInstance.get(
    addParamsToUrl(requestUrl, {
      end,
      start,
      is_test,
      orderBy,
      direction,
      departmentId,
    }),
    { responseType: 'blob' }
  );
};

export const getAppointmentDeclineReasons = ({
  end,
  start,
  is_test,
  hospitalId,
}: {
  end: string;
  start: string;
  is_test: string;
  hospitalId: string | number;
}) => {
  const url = generateUrl(URL.GET_CASES_NOT_BOOKED, {
    id: hospitalId,
  });

  return apiInstance.get(
    addParamsToUrl(url, {
      end,
      start,
      is_test,
    })
  );
};

export const getLineChartsData = ({
  end,
  start,
  is_test,
  hospitalId,
}: {
  end: string;
  start: string;
  is_test: string;
  hospitalId: string | number;
}) => {
  const url = generateUrl(URL.GET_LINE_CHARTS_DATA, {
    id: hospitalId,
  });

  return apiInstance.get(
    addParamsToUrl(url, {
      end,
      start,
      is_test,
    })
  );
};

export const getAppointmentConversionRateData = ({
  end,
  start,
  is_test,
  hospitalId,
}: {
  end: string;
  start: string;
  is_test: string;
  hospitalId: string | number;
}) => {
  const url = generateUrl(URL.GET_APPOINTMENT_CONVERSION_RATE_DATA, {
    id: hospitalId,
  });

  return apiInstance.get(
    addParamsToUrl(url, {
      end,
      start,
      is_test,
    })
  );
};

export const getAbandonedCallsData = ({
  end,
  start,
  is_test,
  hospitalId,
}: {
  end: string;
  start: string;
  is_test: string;
  hospitalId: string | number;
}) => {
  const url = generateUrl(URL.GET_ABANDONED_CALLS_DATA, {
    id: hospitalId,
  });

  return apiInstance.get(
    addParamsToUrl(url, {
      end,
      start,
      is_test,
    })
  );
};

export const getCampaignAnalytics = ({
  end,
  start,
  hospitalId,
}: {
  end: string;
  start: string;
  hospitalId: string | number;
}) => {
  return apiInstance.get(
    addParamsToUrl(URL.GET_CAMPAIGN_ANALYTICS + '/' + hospitalId, {
      endDate: end,
      startDate: start,
    })
  );
};
